/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2020-12-09 14:13:42
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-09 14:50:44
 */
export default {
  lang: "ar",
  detail: {
    name1: "هاتف",
    name2:"استشار",
    name4:"سلعة",
    name5:"تفاصيل",
    name6:"توزيع",
    name7:"مختار",
    name8:"شراء",
    name9:"افتح تطبيق Carlcare للشراء",
    name10:"ترويج المبيعات",
    name11:"تفاصيل المنتج",
    name12:"خصم الطلب الأول",
    name13:"ترويج",
    name14:"",
  }
};